// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3nslc","form":"styles_form__1lNbi"};